import * as yup from 'yup';

type TFunction = (key: string, options?: Record<string, unknown>) => string;

export const initialAddressDto = {
  street: '',
  additionalStreet: '',
  cityId: '',
  cityName: '',
  countryName: '',
};

export const addressDtoSchema = (translate: TFunction) => {
  return yup.object().shape({
    street: yup.string().required(translate('REQUIRED')),
    additionalStreet: yup.string(),
    cityId: yup.string(),
    cityName: yup.string().required(translate('REQUIRED')),
    countryName: yup.string().required(translate('REQUIRED')),
    countryId: yup.string().required(translate('REQUIRED')),
  });
};
